import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getReferral} from '../../../apis/cashback/getReferral'

const useQueryReferral = (exchange?: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.payback.getReferral(exchange),
        queryFn: async () => {
            const {data} = await getReferral(exchange)
            return {data}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryReferral
